import { Box } from '@mui/material'
import { EmtTypography, EmtAvatar, EmtCheckbox } from 'emt-components-v2'

interface UserBoxProps {
  data: {
    avatar?: {
      imageThumbnailUrl?: string
    }
    name?: string
    icon?: string
    id: string
  }
  onClick?: () => void
  isSelected: boolean
  checkbox?: boolean
}

const UserBox: React.FC<UserBoxProps> = ({ data, onClick, isSelected, checkbox }) => {
  return (
    <Box onClick={onClick}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '5px',
          padding: '8px',
          backgroundColor: isSelected ? '#F9F9F9' : '#fff',
          borderRadius: '16px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          <Box
            className="EmtInlineCard-image-wrapper"
            sx={{
              position: 'relative',
              width: '48px',
              height: '48px',
              overflow: 'hidden',
              display: 'flex',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            {data.avatar?.imageThumbnailUrl && (
              <EmtAvatar
                sx={{ flexShrink: 0, height: '100%!important', width: '100%', borderRadius: '14px' }}
                size="large"
                src={data.avatar.imageThumbnailUrl}
              />
            )}
          </Box>
          <EmtTypography variant="body1" fontWeight="700">
            {data.name}
          </EmtTypography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
          }}
        >
          {checkbox && (
            <EmtCheckbox
              sx={{
                backgroundColor: '#fff',
                '& .emt-tick': { backgroundColor: '#AE59C6' },
                '& .emt-icons': {
                  borderColor: isSelected ? '#F9F9F9' : '#D2D1D4',
                },
              }}
              checked={isSelected}
              size="medium"
              value={data.id}
            />
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default UserBox
